export { Shapes as default } from './Shapes';
